import { useQueryGetProjectIsShowPredictionLikelihood } from 'api/queries/getProjectIsShowPredictionLikelihood';

import { ShowPredictionLikelihood } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/ProjectPreferences/EditIsShowPredictionLikelihood/components/ShowPredictionLikelihood';

interface Props {
    projectId: number;
}

export const EditIsShowPredictionLikelihood = ({ projectId }: Props) => {
    const { data: isShow } = useQueryGetProjectIsShowPredictionLikelihood({ projectId });
    if (isShow === undefined) return null;

    return <ShowPredictionLikelihood isShow={isShow} projectId={projectId} />;
};
